import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Loading from "../utils/loading/Loading";
import { patientRequest, getPlaylistVideo } from "./actions";
import styles from "./WallVideo.scss";
import edit from "./ModalVideo.scss";
import poster1 from "../playlists/posterImage/thumb.png";
import Modal from "./ModalVideo";
import PageError from "./404Page/404Page";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import { getSubdomainUrl } from "./PatientPlaylistTools";

class VideoView extends React.Component {
  static propTypes = {
    "video-patient": PropTypes.objectOf(PropTypes.any).isRequired,
    patientRequest: PropTypes.func.isRequired,
    "playlist-videos": PropTypes.objectOf(PropTypes.any).isRequired,
    getPlaylistVideo: PropTypes.func.isRequired,
  };
  constructor() {
    super();
    this.state = {
      videos: [],
      modal: false,
      srcVideo: "",
      getAccount: false,
      nbVideosWant: 0,
      fullVideos: false,
    };
  }

  componentDidMount() {
    const sd = getSubdomainUrl();
    this.props.patientRequest({ subdomain: sd });
    const query = new URLSearchParams(this.props.location.search);
    this.setState({
      nbVideosWant: parseInt(query.get("videos")),
    });
  }

  componentDidUpdate() {
    if (!this.state.getAccount) {
      this.getPlaylist();
    }
    console.log(this.state.nbVideosWant);
    if (isNaN(this.state.nbVideosWant)) {
      console.log("ICI");
      return this.setState({
        nbVideosWant: 0,
        fullVideos: true,
      });
    }
  }

  getPlaylist = () => {
    if (typeof this.props["playlist-videos"].playVideo === "undefined") {
      const {
        "playlist-videos": { authData },
      } = this.props;
      if (authData) {
        // console.log('getPlaylist: authData not empty', authData);
        this.props.getPlaylistVideo(authData);

        this.setState({
          getAccount: true,
        });
      }
    }
  };

  // getPlaylist = () => {
  //     if (typeof this.props['playlist-videos'].playVideo === 'undefined') {
  //         this.props.getPlaylistVideo();
  //     }
  // }

  handleRetryCategories = () => {
    const sd = getSubdomainUrl();
    this.props.patientRequest({ subdomain: sd });
  };

  showModal = (SRC) => {
    // console.log('source file : ', SRC.video);
    const sourceFile = SRC.video;
    if (sourceFile === null) {
      return;
    }
    if (!this.state.modal) {
      this.setState({
        modal: true,
        srcVideo: sourceFile,
      });
    }
  };

  backToTheWall = () => {
    this.setState({
      modal: false,
      srcVideo: "",
    });
  };

  render() {
    const {
      "video-patient": { userinfoError },
      // Props needed for the video wall
      "playlist-videos": {
        playVideo,
        playlistVideoRequesting,
        playlistVideoError,
        playlistVideoSuccessful,
      },
    } = this.props;

    // Source iframe by ShowModal(SRC)
    const srcIframe = this.state.srcVideo;

    return (
      <div>
        {/* Loader */}
        {playlistVideoRequesting && <Loading size={80} />}
        {/* Section where all the cards are found */}
        <section id="Iframe" className={(styles.second, styles.clearfix)}>
          {/* Check width props */}
          {playlistVideoSuccessful &&
            !playlistVideoError &&
            !playlistVideoRequesting &&
            // Map on the data
            playVideo.map((video, i) => {
              if (i <= this.state.nbVideosWant - 1 || this.state.fullVideos) {
                return (
                  <article
                    className={styles.video}
                    id={styles.playDisplay}
                    key={video.id}
                    onClick={(e) => this.showModal({ video: video.file })} // showModal(SRC) receives obj video
                  >
                    <figure id={styles.pop_up} className={styles.figure}>
                      {/* Picture on the card */}
                      <a className={styles.fancybox}>
                        <img
                          className={styles.videoThumb}
                          src={
                            video.posterImage === undefined
                              ? poster1
                              : video.posterImage
                          }
                        />
                      </a>
                      <a id={styles.iconPlayer}>
                        <PlayCircleOutlineIcon id={styles.sizePlayer} />
                      </a>
                    </figure>
                    {/* Title card */}
                    <h2 className={styles.videoTitle}>{video.description}</h2>
                  </article>
                );
              }
            })}
          {/* {!this.state.fullVideos &&
                        <a className={edit.btnMore} onClick={() => {this.setState({fullVideos: true})}}>Voir plus...</a>
                    } */}
          {/* Modal with component Iframe */}
          {this.state.modal && (
            <div>
              <Modal srcIframe={srcIframe} backToTheWall={this.backToTheWall} />
              <div
                className={edit.modal_video}
                id={edit.contentModal}
                onClick={(e) => this.backToTheWall()}
              ></div>
            </div>
          )}
        </section>
        {/* Page 404 */}
        {userinfoError && (
          <div>
            <PageError />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  "video-patient": state["video-patient"],
  "playlist-videos": state["playlist-videos"],
});

export default connect(mapStateToProps, {
  getPlaylistVideo,
  patientRequest,
})(VideoView);



// WEBPACK FOOTER //
// ./src/pages/patientplaylist/VideosView.jsx